// extracted by mini-css-extract-plugin
export default {"topicList":"CourseDetail_topicList__L3Pjz","column":"CourseDetail_column__YKnfh"};